(function($)
{
	$.Redactor.prototype.emoji = function()
	{
		return {
			init: function()
			{
				
				/*var items = [
					['Lorem ipsum...', 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'],
					['Red label', '<b class="label-red">Label</b>']
				];*/

				this.emoji.template = $('<ul id="redactor-modal-list" class="icon-emoji-insert-list">');

				
				for (var i = 0; i < this.opts.emoji.items.length; i++)
				{
					var li = $('<li>');
					var a = $('<a href="#" class="redactor-emoji-link">').html('<span title="' + this.opts.emoji.items[i].shortcode + '" class="icon-emoji icon-emoji-' + this.opts.emoji.items[i].name + '"></span>');
					var div = $('<div class="redactor-emoji">').hide().html('<span title="' + this.opts.emoji.items[i].shortcode + '" class="icon-emoji icon-emoji-' + this.opts.emoji.items[i].name + '"></span>');

					li.append(a);
					li.append(div);
					this.emoji.template.append(li);
				}

				this.modal.addTemplate('emoji', '<div class="modal-section">' + this.utils.getOuterHtml(this.emoji.template) + '</div>');

				var button = this.button.add('emoji', 'Emoji');
				
				this.button.setIcon(button, '<i class="icon icon-smile"></i>');

				this.button.addCallback(button, this.emoji.show);

			},
			show: function()
			{
				this.modal.load('emoji', 'Insert Emoji', 500);

				$('#redactor-modal-list').find('.redactor-emoji-link').each($.proxy(this.emoji.load, this));

				this.modal.show();
			},
			load: function(i,s)
			{
				$(s).on('click', $.proxy(function(e)
				{
					e.preventDefault();
					this.emoji.insert($(s).next().html());

				}, this));
			},
			insert: function(html)
			{
				this.buffer.set();
				this.air.collapsedEnd();
				this.insert.html(html);
				this.modal.close();
			}
		};
	};
})(jQuery);

